angular.module('jv.Admin.Users')
    .controller('jvAdminUsersEmplyeeDetailsController',
        ['$scope', 'adminUserSVC', '$location', '$window', 'breadcrumbsResolve', 'enumToValueMap', 'jvTimezones',
            function($scope, adminUserSVC, $location, $window, breadcrumbsResolve, enumToValueMap, jvTimezones) {
                $scope.flags.loading = false;
                $scope.employee={};
                $scope.breadcrumbsConfig = breadcrumbsResolve;
                $scope.messageModal={};
                $scope.map = enumToValueMap;
                $scope.employeeDefaultSelect = $scope.employeeSelect = adminUserSVC.employeeSelect;
                $scope.i18n_TestDate = new Date();
                $scope.totalCount = 0;
                $scope.pageSize = 10;
                $scope.currentPage = 0;
                $scope.initialPageNumber = 0;
                var timezonesByOpenSysId = {};
                $scope.getEmployeeDetails = function (readMode, msg) {
                    adminUserSVC.getEmployeeDetails($scope.params.id, function (response) {
                        angular.extend($scope.employee, response);
                        if($scope.employee.user) {
                            $scope.employee.profileUrl = '/admin/action/user-details/employee/' + $scope.employee.user.EId + '/profilePhoto?size=m';
                        }
                        if($scope.breadcrumbsConfig && $scope.breadcrumbsConfig.links && $scope.breadcrumbsConfig.links.length < 3){
                            $scope.breadcrumbsConfig.links.unshift({
                                linkText: response.user.firstName + " " + response.user.lastName
                            });
                        }
                        $scope.quickForms.message.to = $scope.employee.user;
                        $scope.employee.user.actions = {};
                        $scope.showPermissionsLink = response.showPermissionLink;
                        angular.forEach(response.actionLinks, function (actionLink) {
                            $scope.employee.user.actions[actionLink.key] = actionLink.value;
                        });
                        
                        /* BE sends login date as string, converting it to Date type to apply angular date filter */
                        if($scope.employee.user.invitationAcceptedDate){
                            $scope.employee.user.invitationAcceptedDate = new Date($scope.employee.user.invitationAcceptedDate);
                        }
                        if($scope.employee.user.invitationSentDate){
                            $scope.employee.user.invitationSentDate = new Date($scope.employee.user.invitationSentDate);
                        }
                        if($scope.employee.user && $scope.employee.user.lastLogout){
                            $scope.employee.user.lastLogout = new Date($scope.employee.user.lastLogout);
                        }

                        $scope.flags.loading = false;
                        if(msg) {
                            $scope.showMsg(msg, true);
                        }
                        getTimezones();
                    }, function (response) {
                        $scope.flags.loading = false;
                    }, readMode);
                };
                $scope.getEmployeeDetails(true);

                function getTimezones() {
                    jvTimezones.getTimezones().then(function(timezones) {
                        timezones.forEach(function(timezone) {
                            timezonesByOpenSysId[timezone.openSysId] = timezone;
                        });
                    });
                }

                $scope.pagination = {
                    page: $scope.params.page,
                    pageSize: 10,
                    total: $scope.params.count,
                    ids: [],
                    list: function(pageIndex, fetchIndex, page, pageSize, arrIndex){
                        if(angular.isDefined(pageIndex)){
                            $scope.flags.loading = true;
                            $scope.pagination.page = page;
                            if(!$scope.pagination.ids.length || pageIndex % pageSize===0){
                                adminUserSVC.getEmployeePagination($.param({page: page}), function(response){
                                    $scope.flags.loading = false;
                                    $scope.pagination.total = response.count;
                                    $scope.pagination.ids = response.employeeIds;
                                    $scope.pagination.pageSize = response.pageSize;
                                    if(angular.isDefined(arrIndex)) {
                                        $location.path('/users/employee/details/'+$scope.pagination.ids[arrIndex]+'/'+fetchIndex+'/'+ $scope.pagination.total + '/' + page);
                                    }
                                });
                            }else{
                                $location.path('/users/employee/details/'+$scope.pagination.ids[arrIndex]+'/'+fetchIndex+'/'+ $scope.pagination.total + '/' + page);
                            }
                        }
                    },
                    next: function(pageIndex){
                        var pageSize = $scope.pagination.pageSize;
                        var page = Math.floor(pageIndex/pageSize);
                        var arrIndex = pageIndex-(page*pageSize);
                        $scope.pagination.list(pageIndex, pageIndex+1, page, pageSize, arrIndex);
                    },
                    previous:function(pageIndex){
                        var fetchIndex = pageIndex-1;
                        var pageSize = $scope.pagination.pageSize;
                        var page = fetchIndex % pageSize===0 ? Math.floor(pageIndex/pageSize)-1 : Math.floor(fetchIndex/pageSize);
                        var arrIndex = fetchIndex-(page*pageSize);
                        $scope.pagination.list(fetchIndex, fetchIndex, page, pageSize, arrIndex-1);
                    }
                };
                //Pagination request on load to get pageSize
                $scope.pagination.list($scope.params.index, $scope.params.index-1, $scope.params.page);

                $scope.type = function (field) {
                    var namePattern = /Name|Phone|Zip|Text|Radio|Number|DropDown/g;
                    var employeePattern = /Employee|EmployeeNoDefault/g;

                    var type = (field && field.fieldType) || "";
                    var fieldId = field && field.fieldId;
                    if(fieldId === -3) {
                        type = "Email";
                    } else if(namePattern.test(type)) {
                        type = "Name";
                    } else if(employeePattern.test(type)) {
                        type = "Employee";
                    } else if(type === "CheckBox") {
                        field.data = field.value && field.value.split('\n');
                    } else if(type === "Date" && !angular.isDate(field.value)) {
                        field.value = new Date(field.value);
                    } 
                    return type;
                };

                $scope.formatFieldValue = function(field) {
                    if (field.fieldId === -31 && field.value && timezonesByOpenSysId[field.value]) {
                        return timezonesByOpenSysId[field.value].name;
                    }
                    return field.value;
                };


                $scope.sendInvite=function(messageType){
                    $scope.flags.loading=true;
                    $scope.selectedRows = [$scope.employee.user];
                    $scope.messageModal={
                        type: 'INVITE',
                        show: true,
                        isAgency: true,
                        showLinks: false,
                        headText: i18n['SEND_INVITE'],
                        showCC: false,
                        showBCC: false,
                        dontshowTemplate: false,
                        agencyType: false,
                        isDetailsPage: true,
                        templates: [],
                        typeInvite: false,
                        templatePlaceHolder: $scope.i18n['MESSAGE_TO_EMPLOYEE'],
                        subjectPlaceHolder: $scope.i18n['MESSAGE_TO_EMPLOYEE'] + ' ' + $scope.i18n['DEFAULT_HEADER']
                    };
                    adminUserSVC.getInviteTemplates(function(response){
                        $scope.messageModal.templates = $scope.select2Options.setTemplates(response.inviteEmployeeTemplate);
                        angular.forEach($scope.messageModal.templates, function(templt){
                            if(templt['default']){
                                $scope.messageModal.template = templt;
                                $scope.messageModal.subject = templt.subject;
                                $scope.messageModal.body = templt.body;
                            }
                        });
                        $scope.flags.loading = false;
                    });
                };

                //Used to send invite. Modal uses sendMessage function to send the invite
                $scope.sendMessage = function () {
                    $scope.messageModal.checkdata = false;
                    if($scope.messageModal.subject.trim() && $scope.messageModal.body.trim()){
                        var postParams = {};
                        postParams['to'] = [];
                        postParams['to'].push($scope.employee.user.EId);
                        postParams['subject'] = $scope.messageModal.subject;
                        postParams['content'] = $scope.messageModal.body;

                        /*BE expects locale to be sent to determine language for Email header/footer*/
                        if($scope.messageModal && $scope.messageModal.template){
                            postParams['locale'] = $scope.messageModal.template['locale'];
                        }
                        adminUserSVC.sendEmployeeInvite(postParams, function(response){
                            $scope.messageModal = {};
                            $scope.selectedEmployee = {};
                            $scope.getEmployeeDetails(true, $scope.i18n['INVITE_SENT']);
                        });
                    }else{
                        $scope.messageModal.checkdata = true;
                    }
                };

                $scope.showLocked= function(isLocked){
                    var text = isLocked ? $scope.i18n['LOCKED_RECORDS'] : $scope.i18n['UNLOCKED_RECORDS'];
                    $scope.$root.modal = {
                        show: true,
                        title: isLocked ? $scope.i18n['LOCK_RECORDS']: $scope.i18n['UNLOCK_RECORDS'],
                        buttons:[
                            {
                                label: isLocked ? $scope.i18n['LOCK']: $scope.i18n['UNLOCK'], title:isLocked ? $scope.i18n['LOCK']: $scope.i18n['UNLOCK'],
                                click: function () {
                                    $scope.flags.loading = true;
                                    var postParams = {};
                                    postParams['lock'] = isLocked;
                                    postParams['userIds'] = [$scope.employee.user.EId];
                                    adminUserSVC.lockRecords(postParams, function (response) {
                                        var msg;
                                        $scope.$root.modal.show = false;
                                        if(isLocked) {
                                            msg = $scope.employee.user.firstName + ' ' + $scope.employee.user.lastName + ' ' + $scope.i18n['HAS_BEEN_LOCKED'];
                                        }
                                        else {
                                            msg = $scope.employee.user.firstName + ' ' + $scope.employee.user.lastName + ' ' + $scope.i18n['HAS_BEEN_UNLOCKED'];
                                        }
                                        $scope.getEmployeeDetails(true, msg);
                                    });
                                    $scope.flags.loading = false;
                                },
                                'class': 'btn'
                            },
                            {
                                label: $scope.i18n['CANCEL'], title: $scope.i18n['CANCEL'],
                                click: function () {
                                    $scope.$root.modal.show = false;
                                },
                                'class': 'btn cancel'
                            }
                        ],
                        isLocked: isLocked,
                        body: $scope.i18n['LOCK_RECORD_MESSAGE'] +' ' + ($scope.employee.user.firstName + ' ' + $scope.employee.user.lastName + ' ' + $scope.i18n['TO'] + ' ' + text + ' ' + $scope.i18n['LIST'] + '?').toLowerCase(),
                    };
                };


                /**
                * @doc function
                * @name $scope.isEmployeeInApprovalChain
                * @description This function checks if an employee is in an approval chain before removing the employee. If true shows a modal
                * @param 
                * @returns no return value
                **/
                $scope.isEmpInApprovalChain = function(page){
                    $scope.flags.loading = true;
                    $scope.currentPage = page;
                    
                    var params = {
                        ownerIds: $scope.employee.user.EId,
                        jobStateValue: 1009,
                        maxResults: $scope.pageSize,
                        page:page
                    };
                    
                    adminUserSVC.getReqsList($.param(params), function(response,code){
                        if(code == 200 && response.jobs.length > 0){
                            $scope.flags.loading = false;
                            $scope.reqList = {};
                            $scope.reqList.response = response;
                            $scope.totalCount = response.jobCount || 0;
                            $scope.reqList.modal = {};
                            $scope.reqList.showRemove = true;
                            $scope.reqList.showRoleUpdate = false;
                            $scope.reqList.modal.show = true;
                            $scope.reqList.modal.header = i18n["REMOVE_EMPLOYEE"];
                        }else{
                            $scope.$root.modal={
                                show:true,
                                cancel: function(){$scope.$root.modal.show = false;},
                                buttons:[
                                            {label: i18n['REMOVE'], title:i18n['REMOVE'], click: function(){$scope.removeEmployee();}, 'class':'btn'},
                                            {label: i18n['CANCEL'], title:i18n['CANCEL'], click: function(){ $scope.$root.modal.show = false;}, 'class': 'btn cancel'}
                                        ],
                                title: i18n['REMOVE_EMPLOYEE']
                            };
                            $scope.$root.modal.body = i18n["EMPLOYEE_REMOVE_CONFIRM"];
                        }
                        $scope.flags.loading = false;
                    });
                };

                $scope.hideEmployeeListModal = function(){
                    $scope.reqList.modal.show = false;
                };

                $scope.removeEmployee = function(){
                    var postParams={};
                    postParams['remove'] = true;
                    postParams['userIds'] = [$scope.employee.user.EId];
                    adminUserSVC.removeEmployee(postParams, function(response){
                        if(response){
                            if(response.msgInfo === 200) {
                                $scope.$root.modal = {};
                                if($scope.reqList && $scope.reqList.modal) {
                                    $scope.reqList.modal.show = false;
                                }
                                $window.location = '/admin/config/users/index.html#/users/employees/EMPLOYEE_HAS_BEEN_REMOVED';
                            }
                            else if(response.msgInfo === 400) {
                                $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                            }
                        }
                    });
                };
                
                $scope.editDetails = function(){
                    $scope.employee.edit = true;
                };

                $scope.quickForms = {};

                $scope.quickForms.note = {
                    to:{},
                    show: false,
                    showError: false,
                    templates: [],
                    currentTemplate:{},
                    showTemplate: false,
                    showToggle: function() {
                        this.show = !this.show;
                        $scope.quickForms.current = 'note';
                        if(!this.templates.length) {
                            this.getTemplates();
                        }
                    },
                    cancel: function() {
                        this.showToggle();
                    },
                    getTemplates: function() {
                        $scope.quickForms.note.subject = '';
                        $scope.quickForms.note.body = '';

                        adminUserSVC.getNoteTemplates(function(response) {
                            if(response && !$.isEmptyObject(response)) {
                                $scope.quickForms.note.templates = response.employeeMessageTempate;
                                $scope.quickForms.note.showTemplate = true;
                            }
                        });
                    },
                    setTemplate: function(templateEId) {
                        /*Set subject and content from template*/
                        angular.forEach($scope.quickForms.note.templates, function (template) {
                            if(template.EId == templateEId){
                                $scope.quickForms.note.subject= template.subject;
                                $scope.quickForms.note.body= template.body;
                            }
                        });
                    },
                    send: function(){
                        if(!$scope.quickForms.note.subject){
                            $scope.quickForms.note.showError = true;
                            return;
                        }
                        var postParams = {};
                        postParams.to = $scope.quickForms.message.to.EId;
                        postParams.bcc = postParams.cc = [];
                        postParams.subject = $scope.quickForms.note.subject;
                        postParams.content = $scope.quickForms.note.body;
                        $scope.flags.loading = true;

                        adminUserSVC.saveEmployeeNote(postParams, function(response){
                            if(response.msgInfo === 200) {
                                $scope.showMsg('NOTE_SENT');
                            } else {
                                $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                            }
                            $scope.flags.loading = false;
                            $scope.quickForms.note.showError = false;
                            $scope.quickForms.note.showToggle();
                        });
                    }
                };
                $scope.quickForms.message = {
                    to:{},
                    show: false,
                    showError: false,
                    templates: [],
                    currentTemplate:{},
                    showTemplate: false,
                    showToggle: function() {
                        this.show = !this.show;
                        if(!this.templates.length) {
                            this.getTemplates();
                        }
                    },
                    cancel: function() {
                        this.showToggle();
                    },
                    getTemplates: function() {
                        $scope.quickForms.message.subject = '';
                        $scope.quickForms.message.body = '';

                        adminUserSVC.getMessageTemplates(function(response) {
                            if(response && !$.isEmptyObject(response)) {
                                $scope.quickForms.message.templates = response.employeeMessageTempate;
                                $scope.quickForms.message.showTemplate = true;
                            }
                        });
                    },
                    setTemplate: function(templateEId) {
                        /*Set subject and content from template*/
                        angular.forEach($scope.quickForms.message.templates, function (template) {
                            if(template.EId == templateEId){
                                $scope.quickForms.message.subject= template.subject;
                                $scope.quickForms.message.body= template.body;
                            }
                        });
                    },
                    send: function(){
                        if(!$scope.quickForms.message.subject){
                            $scope.quickForms.message.showError = true;
                            return;
                        }
                        var postParams = {};
                        postParams.to = $scope.quickForms.message.to.EId;
                        postParams.bcc = postParams.cc = [];
                        postParams.subject = $scope.quickForms.message.subject;
                        postParams.content = $scope.quickForms.message.body;
                        $scope.flags.loading = true;

                        adminUserSVC.sendEmployeeMessage(postParams, function(response){
                            if(response.msgInfo === 200) {
                                $scope.showMsg('MESSAGE_SENT');
                            } else {
                                $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                            }
                            $scope.flags.loading = false;
                            $scope.quickForms.message.showError = false;
                            $scope.quickForms.message.showToggle();
                        });
                    }
                };

                //Populating subject/body based on selected template 
                $scope.$watch('messageModal.template',function(newVal, oldVal){
                    if(newVal){
                        angular.forEach($scope.messageModal.templates, function(templt){
                            if(templt.eid == newVal.eid){
                                $scope.messageModal.subject = templt.subject;
                                $scope.messageModal.body = templt.body;
                            }
                        });
                    }else{
                        $scope.messageModal.subject = '';
                        $scope.messageModal.body = '';
                    }
                },true);
            }
        ]);